import { useContext, useEffect } from "react";
import Label from "../components/Label";
import { AppContext } from "../App";
import ReactGA from "react-ga4";
import api from "../components/api";

function OrderConfirmed() {
	const { lastOrderId, setLastOrderId, lastOrderNumber, setLastOrderNumber, lastOrderTotal, settings, user, lang } =
		useContext(AppContext);
	const queryParams = new URLSearchParams(window.location.search);
	const queryOrderId = queryParams.get("order_id");
	const queryOrderNumber = queryParams.get("number") || queryParams.get("order_number");
	const displayOrderId = queryOrderId || lastOrderId;
	const displayOrderNumber = queryOrderNumber || lastOrderNumber;
	const orderDisplayNumber =
		displayOrderNumber && displayOrderNumber != displayOrderId
			? `N.${displayOrderNumber} - ID:${displayOrderId}`
			: `ID:${displayOrderId}`;

	useEffect(() => {
		const orderId = queryParams.get("order_id");
		const orderNumber = queryParams.get("number") || queryParams.get("order_number");
		console.log(orderId);
		if (orderId) {
			setLastOrderId(orderId);
			setLastOrderNumber(orderNumber || orderId);
			if (!orderNumber) loadOrderNumber(orderId);
			track_purchase(lastOrderTotal, orderId);
		} else {
			track_purchase(lastOrderTotal, lastOrderId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	async function loadOrderNumber(orderId) {
		if (!user) return;

		const response = await api.postProtected("/orders/get/" + orderId + "/", { lang: lang });
		const order = response.data || response.row || response.order || response;
		if (response.success != 0 && order?.number) setLastOrderNumber(order.number);
	}

	function track_purchase(value, transaction_id) {
		if (settings && settings.website.google_analytics) {
			ReactGA.event("purchase", {
				currency: "EUR",
				value: value,
				transaction_id: transaction_id,
			});
		}
	}

	return (
		<div className="page">
			<div className="container">
				<h1>
					<Label number={84} />
				</h1>
				<p>
					<Label number={85} />
				</p>
				<p>
					<Label number={86} /> {orderDisplayNumber}
				</p>
			</div>
		</div>
	);
}

export default OrderConfirmed;
